import React, { PropsWithChildren } from 'react';
import { useStyles } from './FlowstepContainer.styles';

export const FlowstepContainer: React.FC<PropsWithChildren> = ({ children }) => {
  const styles = useStyles();

  return (
    <div className={styles.flowstepContainer}>
      {children}
    </div>
  )
};